import { Eleicao } from './../../models/eleicao.model';
import { StorageService } from './../../services/storage.service';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-termo-aceite',
  templateUrl: './termo-aceite.component.html',
  styleUrls: ['./termo-aceite.component.css']
})
export class TermoAceiteComponent implements OnInit {
  @Input() eleicaoParametrizacao: any;

  checked: boolean;
  eleicao: Eleicao;
  showPage: boolean = false;

  termo: any;
  instrucao:any;
  token: any;
  idEleicao: number;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected storage: StorageService,
    private eleicaoServices: EleicaoService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.spinner.hide();
    if(this.eleicaoParametrizacao) {
      this.termo = this.eleicaoParametrizacao.termo;
      this.instrucao = this.eleicaoParametrizacao.instrucao;
    } else {
      this.eleicao = new Eleicao();
      this.checked = false;

      var infoEleitor = JSON.parse(sessionStorage.getItem("infoEleitor"));
      this.token = sessionStorage.getItem("token");
      this.idEleicao = infoEleitor.idEleicao;
      this.getEleicaoPorId();

      if (sessionStorage.getItem('termoAceite') != null && sessionStorage.getItem('termoAceite') == 'aceito') {
        this.router.navigate(['../candidatos'], {relativeTo: this.route})
      }
    }
  }

  public getTermoAceitoAvancar() {
    sessionStorage.setItem('termoAceite', 'aceito');
    this.spinner.show();
    this.router.navigate(['../candidatos'], {relativeTo: this.route})
  }

  public getEleicaoPorId() {
    this.eleicaoServices.getById(this.idEleicao, this.token).then(result => {
      this.eleicao = result;
      sessionStorage.setItem("eleicao", JSON.stringify(result));
      this.storage.getEleicao();
      this.termo = this.eleicao.termo;
      this.instrucao = this.eleicao.instrucao
      this.spinner.hide();
    }, error => { })
  }
}
